export class Filter {
    id: number;
    peerCount: number;
    peers: number[];
}
